import type {Message} from '@bufbuild/protobuf';
import type {GenEnum, GenFile, GenMessage} from '@bufbuild/protobuf/codegenv2';
import {enumDesc, fileDesc, messageDesc} from '@bufbuild/protobuf/codegenv2';

export const file_fluxer_user_preferences_v1_pickers: GenFile =
	fileDesc(
		'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',
	);

export type UsageStat = Message<'fluxer.user.preferences.v1.UsageStat'> & {
	count: number;

	lastUsedMs: bigint;
};

export const UsageStatSchema: GenMessage<UsageStat> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 0);

export type EmojiPickerState = Message<'fluxer.user.preferences.v1.EmojiPickerState'> & {
	usage: {[key: string]: UsageStat};

	favoriteEmojiIds: Array<string>;

	collapsedCategoryIds: Array<string>;
};

export const EmojiPickerStateSchema: GenMessage<EmojiPickerState> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 1);

export type StickerPickerState = Message<'fluxer.user.preferences.v1.StickerPickerState'> & {
	usage: {[key: string]: UsageStat};

	favoriteStickerIds: Array<string>;

	collapsedCategoryIds: Array<string>;
};

export const StickerPickerStateSchema: GenMessage<StickerPickerState> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 2);

export type MemesPickerState = Message<'fluxer.user.preferences.v1.MemesPickerState'> & {
	usage: {[key: string]: UsageStat};

	favoriteMemeIds: Array<string>;

	collapsedCategoryIds: Array<string>;
};

export const MemesPickerStateSchema: GenMessage<MemesPickerState> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 3);

export type EmojiState = Message<'fluxer.user.preferences.v1.EmojiState'> & {
	skinTone: string;
};

export const EmojiStateSchema: GenMessage<EmojiState> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 4);

export type EmojiStickerLayoutSettings = Message<'fluxer.user.preferences.v1.EmojiStickerLayoutSettings'> & {
	emojiLayout: EmojiPickerLayout;

	stickerViewMode: StickerPickerViewMode;
};

export const EmojiStickerLayoutSettingsSchema: GenMessage<EmojiStickerLayoutSettings> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 5);

export type FavoriteGifSettings = Message<'fluxer.user.preferences.v1.FavoriteGifSettings'> & {
	entries: Array<FavoriteGifEntry>;

	saveAsSavedMedia: boolean;

	seenFirstTimePrompt: boolean;
};

export const FavoriteGifSettingsSchema: GenMessage<FavoriteGifSettings> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 6);

export type FavoriteGifMediaFormat = Message<'fluxer.user.preferences.v1.FavoriteGifMediaFormat'> & {
	src: string;

	proxySrc: string;

	width: number;

	height: number;
};

export const FavoriteGifMediaFormatSchema: GenMessage<FavoriteGifMediaFormat> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 7);

export type FavoriteGifEntry = Message<'fluxer.user.preferences.v1.FavoriteGifEntry'> & {
	url: string;

	proxyUrl: string;

	width: number;

	height: number;

	media: {[key: string]: FavoriteGifMediaFormat};

	contentType: string;
};

export const FavoriteGifEntrySchema: GenMessage<FavoriteGifEntry> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 8);

export type SoundSettings = Message<'fluxer.user.preferences.v1.SoundSettings'> & {
	allSoundsDisabled: boolean;

	masterVolume?: number | undefined;

	disabledSounds: {[key: string]: boolean};

	soundOverrides: {[key: string]: number};
};

export const SoundSettingsSchema: GenMessage<SoundSettings> =
	messageDesc(file_fluxer_user_preferences_v1_pickers, 9);

export enum EmojiPickerLayout {
	UNSPECIFIED = 0,

	LIST = 1,

	GRID = 2,
}

export const EmojiPickerLayoutSchema: GenEnum<EmojiPickerLayout> =
	enumDesc(file_fluxer_user_preferences_v1_pickers, 0);

export enum StickerPickerViewMode {
	UNSPECIFIED = 0,

	COZY = 1,

	COMPACT = 2,
}

export const StickerPickerViewModeSchema: GenEnum<StickerPickerViewMode> =
	enumDesc(file_fluxer_user_preferences_v1_pickers, 1);

export enum SoundType {
	UNSPECIFIED = 0,

	DEAF = 1,

	UNDEAF = 2,

	MUTE = 3,

	UNMUTE = 4,

	MESSAGE = 5,

	INCOMING_RING = 6,

	USER_JOIN = 7,

	USER_LEAVE = 8,

	USER_MOVE = 9,

	VIEWER_JOIN = 10,

	VIEWER_LEAVE = 11,

	VOICE_DISCONNECT = 12,

	CAMERA_ON = 13,

	CAMERA_OFF = 14,

	SCREEN_SHARE_START = 15,

	SCREEN_SHARE_STOP = 16,
}

export const SoundTypeSchema: GenEnum<SoundType> = /*@__PURE__*/ enumDesc(file_fluxer_user_preferences_v1_pickers, 2);
